import { Component } from 'react'
import _ from 'lodash'
import dayjs from 'dayjs'
import { colors } from '@lmc/common/constants'
import StoolTable from './StoolTable'
import { StoolColormap } from '../../../../common/utils'
import withToolbar from '../withToolbar'
import Highcharts from './Highcharts'
import { EmptyState, NoDataIcon } from '@lmc/ui-kit'
import chartTitles from '../chartTitles'

class StoolChart extends Component {
  constructor(props) {
    super(props)
    this.formatSeries = this.formatSeries.bind(this)
  }

  formatLogs(logs) {
    return _.chain(logs)
      .groupBy((log) =>
        dayjs(log.timeLogged).startOf('day').add(1, 'h').format()
      )
      .map(
        (value, date) => [Date.parse(dayjs(date).toString()), value.length] // { x: date, y: total };
      )
      .value()
  }

  formatSeries(logs) {
    return _.chain(logs)
      .filter((d) => !d.deleted)
      .map((log) => {
        const value = _.get(log, 'measurements.stool.value')
        return {
          value: value > 0 ? value : 'Other',
          timeLogged: log.timeLogged,
        }
      })
      .groupBy('value')
      .map((rows, group) => ({
        group,
        data: this.formatLogs(rows),
      }))
      .keyBy('group')
      .value()
  }

  render() {
    const { resident, logs } = this.props
    const groups = this.formatSeries(logs)
    const series = []
    ;[1, 2, 3, 4, 5, 6, 7, 'Other'].forEach((group) => {
      series.push({
        name: group > 0 ? `Type ${group}` : 'Other',
        color: StoolColormap[group] || colors.darkgrey,
        data: groups[group] ? groups[group].data : null,
      })
    })

    const config = {
      title: chartTitles.stool,
      subTitle: 'Bristol Stool Scale',
      yAxisLabel: 'Number of bowel movements',
      legendEnabled: true,
      chartType: 'column',
      yAllowDecimals: false,
      tooltip: {
        formatter() {
          return `<strong style="font-size: 10px; opacity: 0.7;">${dayjs(
            this.x
          ).format('dddd Do MMMM YYYY')}</strong><br /><b>${
            this.y
          }</b> bowel movement${this.y > 1 ? 's' : ''} of <b>${
            this.series.name
          }</b>`
        },
      },
      series,
      plotOptions: {
        turboThreshold: 10000,
      },
    }

    return logs && logs.length ? (
      <div>
        <Highcharts config={config} />
        <StoolTable logs={logs} resident={resident} />
      </div>
    ) : (
      <EmptyState
        title="Shoot... No data to show you"
        description="No logs to display"
        icon={<NoDataIcon />}
      />
    )
  }
}

export default withToolbar(StoolChart, {
  pdfExport: {
    title: 'Stool Chart',
  },
  timeWindow: 7 * 4,
})
